import { Handshake, Truck, Mail, Minus } from 'lucide-react';

// Bewusst einfaches Mapping ueber Code-Praefix. Der Admin kann beliebige
// versandarten anlegen; was wir nicht kennen, faellt auf Truck zurueck.
//
// Abholung traegt NICHT das Laden-Symbol (B78): das steht in der
// Quelle-Spalte fuer "im Laden erfasst". Zwei Spalten nebeneinander mit
// demselben Bild waren nicht auseinanderzuhalten. Hier steht die
// Uebergabe an den Kunden, dort die Herkunft der Bestellung.
function pickIcon(code: string | null): typeof Truck {
  if (code === null) return Minus;
  if (code.startsWith('abhol')) return Handshake;
  if (code.startsWith('post')) return Mail;
  return Truck;
}

export function VersandartIcon({
  code,
  label
}: {
  code: string | null;
  label: string | null;
}) {
  const Icon = pickIcon(code);
  return (
    <span
      className="inline-flex h-6 w-6 items-center justify-center text-ink-soft"
      // Klartext im Tooltip — das Symbol allein sagt zu wenig (B78).
      title={label !== null ? `Lieferung: ${label}` : 'Lieferung: nicht festgelegt'}
    >
      <Icon className="h-4 w-4" />
    </span>
  );
}
